var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatreon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2612 6.50838C18.2577 3.95468 16.2688 1.86172 13.9353 1.10653C11.0375 0.168753 7.21564 0.304679 4.4486 1.61023C1.0949 3.19283 0.0413797 6.65949 0.00212048 10.1169C-0.0301017 12.9595 0.253602 20.4463 4.47656 20.4997C7.61434 20.5395 8.08156 16.4963 9.53342 14.5491C10.5664 13.1638 11.8964 12.7725 13.5336 12.3673C16.3475 11.6708 18.2653 9.45005 18.2612 6.50838Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreon);
export default __webpack_public_path__ + "static/media/patreon.056870bd.svg";
export { ForwardRef as ReactComponent };